"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
class GetDefaultPropositionsResponseCombinationDetails extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, base_models_1.IsNullable)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.ExposeNameCase)(base_models_1.ExposeNameCaseEnum.LOWER_CASE),
    (0, base_models_1.Docs)({ example: 'G_H_B', description: 'Product key' }),
    tslib_1.__metadata("design:type", Object)
], GetDefaultPropositionsResponseCombinationDetails.prototype, "productKey", void 0);
exports.default = GetDefaultPropositionsResponseCombinationDetails;
